// extracted by mini-css-extract-plugin
export default {"color":"styles_color__+JAEo","gt":"styles_gt__Q5WRo"};